import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/react';
import { BrowserOptions } from '@sentry/react';
import { Env } from '@yaotai/yaotai-tracker';
import { BackendAxiosError, isNode } from '@yaotai/common-utils';
import { REGEX_NETEASE_URL, REGEX_QA_NETEASE_URL } from '../constants';

export const initSentry = ({
  dsn,
  package_version,
  env,
  ...props
}: BrowserOptions & {
  package_version?: string;
  env?: string;
}) => {
  if ([REGEX_NETEASE_URL, REGEX_QA_NETEASE_URL].some(item => item.test(window.location.origin))) {
    Sentry.init({
      dsn,
      integrations: [new BrowserTracing()],
      environment: env,
      // 未开启全量事务监控
      tracesSampleRate: env === Env.Prod ? 0.2 : 1,
      sampleRate: env === Env.Prod ? 0.2 : 1,
      // 只允许网易 URL【prod 和 qa】
      allowUrls: [REGEX_NETEASE_URL, REGEX_QA_NETEASE_URL],
      initialScope: scope => {
        scope.setTags({ package_version: package_version });
        return scope;
      },
      release: __PACKAGE_VERSION__,
      ...props,
    });
  }
};

export function reportSentryError(error: BackendAxiosError) {
  if (error.response) {
    Sentry.withScope(scope => {
      scope.setExtra('response', error.response);
      scope.setExtra('href', isNode ? '' : window.location.href);
      Sentry.captureException(error);
    });
  } else {
    Sentry.withScope(scope => {
      scope.setExtra('href', isNode ? '' : window.location.href);
      Sentry.captureException(error);
    });
  }
}
